import { useEffect, useState } from 'react';

import moment from 'jalali-moment';
import { Link, useLocation } from 'react-router-dom';

import Loading from '../../Shared/Components/Loading';
import Pagination from '../../Shared/Components/Pagination';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { number_format } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const WalletHistory = () => {
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState({ data: [], meta: {} });

  useEffect(() => {
    getTransactions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search]);

  const getTransactions = async () => {
    setLoading(true);
    await useApi.get(
      `/wallet/transactions${search}`,
      {},
      (res) => {
        setTransactions(res.data);
        setLoading(false);
      },
      () => {
        setLoading(false);
        error('هنگام دریافت تاریخچه کیف پول خطایی رخ داده است');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master title='تاریخچه کیف پول'>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            تاریخچه کیف پول
          </h1>
        </div>
        <Link
          to='/panel/matches/financial-management/increase-wallet'
          className='d-flex flex-row btn btn-outline-info'
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>افزایش کیف پول</span>
        </Link>
      </div>
      <div className='w-100 overflow-auto'>
        {transactions?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نوع</th>
                <th>مبلغ (ریال)</th>
                <th>موجودی پس از تراکنش (ریال)</th>
                <th>توضیحات</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {transactions.data.map((item) => (
                <tr key={item.id}>
                  <th>{item.id}</th>
                  <td>{item.type_label}</td>
                  <td>{number_format(item.amount)}</td>
                  <td>{number_format(item.balance_after)}</td>
                  <td>{item.description}</td>
                  <td>
                    {item.created_at
                      ? moment(item.created_at).locale('fa').format('jYYYY/jMM/jDD HH:mm')
                      : '-'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3'>
            <span className='f-13 font-weight-bold text-secondary'>
              هنوز تراکنشی در کیف پول ثبت نشده است
            </span>
          </div>
        )}
      </div>
      <div className='w-100 mt-4 d-flex'>
        <Pagination
          totalPage={transactions?.meta?.pagination?.total_pages}
          basePath='/panel/matches/financial-management/wallet-history'
        />
      </div>
    </Master>
  );
};

export default WalletHistory;
